module.exports = __webpack_public_path__ + "img/paint-slice_01.7dcf35df.jpg";